import { FluxStandardAction as Action } from "flux-standard-action";
import { Dispatch } from "react-redux";
import { ThunkAction } from "redux-thunk";
import type { IStore } from "reducers";

import { isInsightsEnabledWithCurrency } from "reducers/insights-reducer";
import { fetchProductStyleInsights } from "actions/insights/product-style-insights";
import { fetchProductBadges } from "actions/insights/product-badges";
import { clearInsightsData } from "actions/insights-actions";

export type ResetProductInsightsAction = Action<{}, {}>;

export const resetProductInsights = (): ThunkAction<void, IStore, ResetProductInsightsAction> => {
    return (dispatch: Dispatch<IStore>, getState: () => IStore) => {
        const state = getState();

        if (!isInsightsEnabledWithCurrency(state)) {
            return;
        }

        dispatch(clearInsightsData());
        dispatch(fetchProductStyleInsights(null, true));
        dispatch(fetchProductBadges(null, true));
    };
};
